import type { ReactNode } from 'react';
import { QueryProvider } from './QueryProvider';
import { ThemeBootstrap } from './ThemeBootstrap';
import { BootstrapProvider } from '../bootstrap/BootstrapProvider';

interface AppProvidersProps {
  children: ReactNode;
}

/**
 * AppProviders - Wraps an application with all required providers in the correct order:
 * 1. QueryProvider - TanStack Query for server state
 * 2. BootstrapProvider - Load tenant config and initialize stores
 * 3. ThemeBootstrap - Ant Design ConfigProvider with theme
 *
 * Note: BrowserRouter must be provided by the consuming app above this component.
 */
export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryProvider>
      <BootstrapProvider>
        <ThemeBootstrap>{children}</ThemeBootstrap>
      </BootstrapProvider>
    </QueryProvider>
  );
}
